module.exports = __webpack_public_path__ + "img/img-ffp-1@2x.445e9486.jpg";